import {
  GET_CEREMONIES_PACK_SUCCESS,
  GET_CEREMONIES_PACK_FAIL,
  GET_CEREMONY_PACK_PROFILE_SUCCESS,
  GET_CEREMONY_PACK_PROFILE_FAIL,
  ADD_CEREMONY_PACK_SUCCESS,
  ADD_CEREMONY_PACK_FAIL,
  UPDATE_CEREMONY_PACK_SUCCESS,
  UPDATE_CEREMONY_PACK_FAIL,
  DELETE_CEREMONY_PACK_SUCCESS,
  DELETE_CEREMONY_PACK_FAIL,
  DELETE_CEREMONY_PACK,
  ADD_NEW_CEREMONY_PACK,
  UPDATE_CEREMONY_PACK
  
} from "./actionTypes";

const INIT_STATE = {
  ceremonies_pack: [],
  error: {},
  loading:false
};

const ceremonies_pack = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_CEREMONIES_PACK_SUCCESS:
      return {
        ...state,
        ceremonies_pack: action.payload.data,
        total_page:action.payload.total_page
      }

    case GET_CEREMONIES_PACK_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      case ADD_NEW_CEREMONY_PACK:
        return {
          ...state,
          loading:true
        }
    case ADD_CEREMONY_PACK_SUCCESS:
      return {
        ...state,
        ceremonies_pack: [...state.ceremonies_pack, action.payload],
        loading: false,
      }

    case ADD_CEREMONY_PACK_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_CEREMONY_PACK:
        return {
          ...state,
          loading:true
        }
    case UPDATE_CEREMONY_PACK_SUCCESS:
      return {
        ...state,
        ceremonies_pack: state.ceremonies_pack.map(ceremony =>
          ceremony.id.toString() === action.payload.id.toString()
            ? { ...ceremony, ...action.payload }
            : ceremony
        ),
        loading: false,
      }

    case UPDATE_CEREMONY_PACK_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_CEREMONY_PACK:
      return {
        ...state,
        loading:true
      }
    case DELETE_CEREMONY_PACK_SUCCESS:
      return {
        ...state,
        ceremonies_pack: state.ceremonies_pack.filter(
          ceremony => ceremony.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_CEREMONY_PACK_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CEREMONY_PACK_PROFILE_SUCCESS:
      return {
        ...state,
        ceremonyProfile: action.payload,
      }

    case GET_CEREMONY_PACK_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default ceremonies_pack;
